import moment from 'moment';
import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

import COLORS from '../../theme/colors';
import Card from '../generic/Card/Card';
import Graph from '../generic/Graphs/Graph';
import type { IssueCount } from '../../../shared/types/routes/issueCounts';

import styles from './IssueOverview.module.less';
import { generatePoints } from './snapshotUtils';

type Props = {
  items: IssueCount[];
  isLoading: boolean;
  start: Date;
  end: Date;
};

const GraphLoading: VoidFunctionComponent = () => (
  <ContentLoader width="100%" height="345px" foregroundColor={COLORS.fossaGray05} backgroundColor={COLORS.fossaGray10}>
    <rect x="0" y="0" rx="3" ry="3" width="25%" height="21px" />
    <rect x="0" y="45" rx="3" ry="3" width="100%" height="259px" />
    <rect x="33%" y="324px" rx="3" ry="3" width="33%" height="21" />
  </ContentLoader>
);

const IssueHistoryGraph: VoidFunctionComponent<Props> = ({ items, isLoading, start, end }) => {
  let points = generatePoints(start, end, items);

  // If we only have one point, we'll add two virtual points to either side to make a line.
  // It's not perfect because the virtual points have tooltips, but it's better than just a few dots in the middle.
  if (points.length === 1 && points[0]) { // Extra check for points[0] satisfies the compiler and covers the case of [null].
    points = [
      {
        name: null,
        data: points[0].data,
      },
      points[0],
      {
        name: null,
        data: points[0].data,
      },
    ];
  }

  return (
    <div className={styles.section}>
      <Card isFullWidth variant="fill">
        {!isLoading && <Card.Header>{moment(start).format('MMMM YYYY')} - {moment(end).format('MMMM YYYY')}</Card.Header>}
        <Card.Content>
          {isLoading ? <GraphLoading /> : (
            <Graph
              points={points}
              areas={[
                { dataKey: 'remediated', strokeColor: COLORS.fossaGreen },
                { dataKey: 'ignored', strokeColor: COLORS.fossaPurple },
                { dataKey: 'active' },
              ]}
              yAxisConfig={{
                label: 'Count of issues',
              }}
              showLegend
              showTooltips
            />
          )}
        </Card.Content>
      </Card>
    </div>
  );
};

export default IssueHistoryGraph;
